import { Modality } from '~/domain/dicom/modality';

/**
 * Returns the appropriate background pixel value for regions outside
 * the source volume when resampling with an orientation change.
 * CT uses -1024 HU (air), MR and PT use 0 (signal void).
 */
export function getModalityBackgroundValue(modality: Modality): number {
    switch (modality) {
        case Modality.CT:
            return -1024;
        case Modality.MR:
        case Modality.PT:
        default:
            return 0;
    }
}
